export default __webpack_public_path__ + "static/media/regreenbus_info_img.30ffcd54.png";